<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Work Order Execution" active>

                                <b-row v-if="hasFailedDataWorkOrderExecution">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedWorkOrderExecution.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderExecutionsFailed" :fields="fieldsWorkOrderExecution" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderExecution" :sort-desc.sync="sortDescWorkOrderExecution" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(startProduction)="row">
													{{ row.item.startProduction | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(finishProduction)="row">
													{{ row.item.finishProduction | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(qtyPlan)="row">
													{{ Number(row.item.qtyPlan).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedWorkOrderExecution.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderExecutions" :fields="fieldsWorkOrderExecution" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderExecution" :sort-desc.sync="sortDescWorkOrderExecution" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(startProduction)="row">
													{{ row.item.startProduction | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(finishProduction)="row">
													{{ row.item.finishProduction | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(qtyPlan)="row">
													{{ Number(row.item.qtyPlan).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Work Order Execution Detail" active>

                                <b-row v-if="hasFailedDataWorkOrderExecutionDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedWorkOrderExecutionDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderExecutionDetailsFailed" :fields="fieldsWorkOrderExecutionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderExecutionDetail" :sort-desc.sync="sortDescWorkOrderExecutionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(goodQty)="row">
													{{ Number(row.item.goodQty).toLocaleString() }}
												</template>
												<template #cell(pendingQty)="row">
													{{ Number(row.item.pendingQty).toLocaleString() }}
												</template>
												<template #cell(totalQty)="row">
													{{ Number(row.item.totalQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedWorkOrderExecutionDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderExecutionDetails" :fields="fieldsWorkOrderExecutionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderExecutionDetail" :sort-desc.sync="sortDescWorkOrderExecutionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(goodQty)="row">
													{{ Number(row.item.goodQty).toLocaleString() }}
												</template>
												<template #cell(pendingQty)="row">
													{{ Number(row.item.pendingQty).toLocaleString() }}
												</template>
												<template #cell(totalQty)="row">
													{{ Number(row.item.totalQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Work Order Execution Control Time" active>

                                <b-row v-if="hasFailedDataWorkOrderExecutionControlTime">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedWorkOrderExecutionControlTime.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderExecutionControlTimesFailed" :fields="fieldsWorkOrderExecutionControlTime" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderExecutionControlTime" :sort-desc.sync="sortDescWorkOrderExecutionControlTime" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(startControlTime)="row">
													{{ row.item.startControlTime | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(stopControlTime)="row">
													{{ row.item.stopControlTime | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedWorkOrderExecutionControlTime.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderExecutionControlTimes" :fields="fieldsWorkOrderExecutionControlTime" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderExecutionControlTime" :sort-desc.sync="sortDescWorkOrderExecutionControlTime" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(startControlTime)="row">
													{{ row.item.startControlTime | moment("DD-MMM-YYYY HH:mm") }}
												</template>
												<template #cell(stopControlTime)="row">
													{{ row.item.stopControlTime | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
import WorkOrderExecutionList from '@/models/WorkOrderExecution/WorkOrderExecutionList';
import WorkOrderExecutionFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsWorkOrderExecution: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Shift", key: 'shiftName', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process Number", key: 'workOrderProcessDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Work Order Sub Process", key: 'billOfProcessDetailSequence', sortable: false},
				{"class" : "th-status", "label" : "Machine", key: 'machineCode', sortable: false},
				{"class" : "th-status", "label" : "Operator", key: 'operatorFirstName', sortable: false},
				{"class" : "th-status", "label" : "Start Production", key: 'startProduction', sortable: false},
				{"class" : "th-status", "label" : "Finish Production", key: 'finishProduction', sortable: false},
				{"class" : "th-status", "label" : "Qty Plan", key: 'qtyPlan', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsWorkOrderExecutionDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process Detail Id", key: 'workOrderProcessDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Good Qty", key: 'goodQty', sortable: false},
				{"class" : "th-status", "label" : "Pending Qty", key: 'pendingQty', sortable: false},
				{"class" : "th-status", "label" : "Total Qty", key: 'totalQty', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsWorkOrderExecutionControlTime: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Production Control Time", key: 'productionControlTimeStandarTimeId', sortable: false},
				{"class" : "th-status", "label" : "Start Control Time", key: 'startControlTime', sortable: false},
				{"class" : "th-status", "label" : "Stop Control Time", key: 'stopControlTime', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			workOrderExecutions : [],
			workOrderExecutionsFailed: [],
			workOrderExecutionId : '',
			sortByWorkOrderExecution: '',
			sortDescWorkOrderExecution: '',
			hasFailedDataWorkOrderExecution: false,
			totalFailedWorkOrderExecution: 0,
			totalSucceedWorkOrderExecution: 0,
			workOrderExecutionDetails : [],
			workOrderExecutionDetailsFailed: [],
			workOrderExecutionDetailId : '',
			sortByWorkOrderExecutionDetail: '',
			sortDescWorkOrderExecutionDetail: '',
			hasFailedDataWorkOrderExecutionDetail: false,
			totalFailedWorkOrderExecutionDetail: 0,
			totalSucceedWorkOrderExecutionDetail: 0,

			workOrderExecutionControlTimes : [],
			workOrderExecutionControlTimesFailed: [],
			workOrderExecutionControlTimeId : '',
			sortByWorkOrderExecutionControlTime: '',
			sortDescWorkOrderExecutionControlTime: '',
			hasFailedDataWorkOrderExecutionControlTime: false,
			totalFailedWorkOrderExecutionControlTime: 0,
			totalSucceedWorkOrderExecutionControlTime: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('workorderexecution/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('workorderexecution/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getWorkOrderExecutionForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getWorkOrderExecutionForUpload : async function() {
			let _this = this;
			this.$http.get('workorderexecution/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.workOrderExecutions = [];
_this.workOrderExecutionDetails = [];
_this.workOrderExecutionControlTimes = [];


					if (response != null) {
						let result = response.data;
						_this.workOrderExecutions = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedWorkOrderExecution = _this.workOrderExecutions.length;

						_this.workOrderExecutionsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataWorkOrderExecution = true;
						_this.totalFailedWorkOrderExecution = 0;
						if(_this.workOrderExecutionsFailed == undefined || _this.workOrderExecutionsFailed.length === 0) _this.hasFailedDataWorkOrderExecution = false;
						if(_this.hasFailedDataWorkOrderExecution) _this.totalFailedWorkOrderExecution = _this.workOrderExecutionsFailed.length;
						_this.workOrderExecutionDetails = [];
						_this.workOrderExecutionDetailsFailed = [];
						_this.hasFailedDataWorkOrderExecutionDetail = true;
						_this.totalSucceedWorkOrderExecutionDetail = 0;
						result.forEach(function(element) {
							_this.workOrderExecutionDetails.push(...element.workOrderExecutionDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedWorkOrderExecutionDetail = _this.workOrderExecutionDetails.length;

							_this.workOrderExecutionDetailsFailed.push(...element.workOrderExecutionDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.workOrderExecutionDetailsFailed == undefined || _this.workOrderExecutionDetailsFailed.length === 0) _this.hasFailedDataWorkOrderExecutionDetail = false;
							if(_this.hasFailedDataWorkOrderExecutionDetail) _this.totalFailedWorkOrderExecutionDetail = _this.workOrderExecutionDetailsFailed.length;
						});						_this.workOrderExecutionControlTimes = [];
						_this.workOrderExecutionControlTimesFailed = [];
						_this.hasFailedDataWorkOrderExecutionControlTime = true;
						_this.totalSucceedWorkOrderExecutionControlTime = 0;
						result.forEach(function(element) {
							_this.workOrderExecutionControlTimes.push(...element.workOrderExecutionControlTime.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedWorkOrderExecutionControlTime = _this.workOrderExecutionControlTimes.length;

							_this.workOrderExecutionControlTimesFailed.push(...element.workOrderExecutionControlTime.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.workOrderExecutionControlTimesFailed == undefined || _this.workOrderExecutionControlTimesFailed.length === 0) _this.hasFailedDataWorkOrderExecutionControlTime = false;
							if(_this.hasFailedDataWorkOrderExecutionControlTime) _this.totalFailedWorkOrderExecutionControlTime = _this.workOrderExecutionControlTimesFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'workorderexecution/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'WorkOrderExecution.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterWorkOrderExecution = new WorkOrderExecutionFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
